import { produce } from 'immer';

import {
    CLOSE_PI_TAGS_EDITOR,
    OPEN_PI_TAGS_EDITOR,
    PAGE_GROUP_TAGS_CHANGE,
    PiTagsEditorAction,
    TARGET_TAGS_CHANGE
} from '../actions/piTagsEditor';
import { PITagsEditorState } from '../typings/piTags';
import { PITagsEditorsState } from '../typings/state';

export const defaultPITagsEditorsState: PITagsEditorState = {
    isOpen: false,
    targetTags: '',
    pageGroupTags: ''
};

export const piTagsEditorsInitialState: PITagsEditorsState = {};

export function piTagsEditor(
    state: PITagsEditorsState = piTagsEditorsInitialState,
    action: PiTagsEditorAction
): PITagsEditorsState {
    switch (action.type) {
        case OPEN_PI_TAGS_EDITOR: {
            return produce(state, draft => {
                draft[action.id] = {
                    targetTags: action.targetTags,
                    pageGroupTags: action.pageTags,
                    isOpen: true
                };
            });
        }

        case CLOSE_PI_TAGS_EDITOR: {
            return produce(state, draft => {
                draft[action.id].isOpen = false;
            });
        }

        case PAGE_GROUP_TAGS_CHANGE:
            return produce(state, draft => {
                draft[action.id].pageGroupTags = action.value;
                draft[action.id].isOpen = true;
            });

        case TARGET_TAGS_CHANGE:
            return produce(state, draft => {
                draft[action.id].targetTags = action.value;
            });

        default:
            return state;
    }
}
